import './global.css'

if (process.env.REACT_APP_MAINTENANCE === 'true') {
  import('./maintenance/index')
} else if (window.location.pathname === '/preview') {
  import('./preview')
} else {
  import('./app')
}
